import { render } from "./cgemima.vue?vue&type=template&id=28623cf0&scoped=true"
import script from "./cgemima.vue?vue&type=script&lang=js"
export * from "./cgemima.vue?vue&type=script&lang=js"

import "./cgemima.vue?vue&type=style&index=0&id=28623cf0&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28623cf0"]])

export default __exports__